var SupportModule = (function () {
    function SupportModule() {
    }
    return SupportModule;
}());
export { SupportModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/support/support.module.ts.pre-build-optimizer.js